import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { DeleteOutlined } from "@mui/icons-material";

export type DeleteCTAProps = {
  onDeleteConfirmed: () => void;
  dialogTitle?: string;
  buttonLabel?: string;
  discreet?: boolean;
};

export const DeleteCTA = ({
  onDeleteConfirmed,
  dialogTitle = "Tem certeza que deseja excluir?",
  buttonLabel = "Deletar",
  discreet = false,
}: DeleteCTAProps) => {
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const handleConfirm = () => {
    onDeleteConfirmed();
    setShowDialog(false);
  };

  return (
    <>
      <Button
        color={discreet ? "secondary" : "error"}
        onClick={() => setShowDialog(true)}
        sx={{
          flexDirection: "row",
          justifyContent: discreet ? "flex-start" : "center",
        }}
      >
        <DeleteOutlined sx={{ mr: 1 }} />
        {discreet ? (
          <Typography variant="caption">{buttonLabel}</Typography>
        ) : (
          buttonLabel
        )}
      </Button>

      <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
        <DialogContent>
          <Typography>{dialogTitle}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            onClick={() => {
              setShowDialog(false);
            }}
          >
            Cancelar
          </Button>
          <Button color="error" onClick={handleConfirm}>
            Excluir
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
